// extracted by mini-css-extract-plugin
export default {"mainLogoWrap":"MainLogo_mainLogoWrap__9iGO1"};